import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../Common/DataTable';
import { DataSheetsData } from './utils/types';
// import { getDataSheet } from './redux/sliceDataSheet';
import { RootState } from '../../redux/rootState';
import { setLoader } from '../../redux/loaderSlice';
import { exportToExcelData } from '../../Common/PageHeader/helper';
import EndPoints from '../../Routes/EndPoints';
import { getJobOrderList } from './redux/sliceDataSheet';
import { defaultPageSize } from '../../utils/Constant';

function ScreenDataSheets() {
  // const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  // const { DataSheet, TotalRecords } = useSelector((state: RootState) => state.dataSheetReducer);
  const { isLoading, jobOrderList, jobOrderTotalData } = useSelector((state: RootState) => state.dataSheetReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };
    dispatch(getJobOrderList(params));
    // dispatch(getDataSheet(params));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const data: DataSheetsData[] = useMemo(() => {
    if (jobOrderList?.length > 0) {
      const transformedData = jobOrderList?.map((item, index) => ({
        sn: index,
        data: item,
        action: 'eye',
        id: item,
      }));
      return transformedData;
    }
    return [];
  }, [jobOrderList]);

  const excelData = useMemo(() => jobOrderList?.map((item) => {
    const transformedDataItem = {
      jobOrder: item,
    };
    return transformedDataItem;
  }), [jobOrderList]);

  const columns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'data', label: 'Job Order' },
    ],
    [],
  );

  const handleViews = (id: string) => {
    window.open(`/${EndPoints.DATASHEETS}/${id}`);
    // Navigate(`${id}`);
  };

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Data_sheet',
    );
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="Data Sheets" downloadExcel={downloadExcel} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <DataTable<DataSheetsData>
          data={data}
          columns={columns}
          totalRecords={jobOrderTotalData}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          searchQuery={searchQuery}
          setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
          sortCol={sortCol}
          setSortCol={(_e) => { setSortCol('data'); setPage(1); }}
          sortDir={sortDir}
          setSortDir={(e) => { setSortDir(e); setPage(1); }}
          handleData={handleData}
          handleViews={handleViews}
          handleDataFromComponent
        />
      </Grid>
    </Grid>
  );
}

export default ScreenDataSheets;
